
import { useEffect, useRef } from 'react';

interface UseAiAssistantEffectsProps {
  currentSessionId: string | null;
  messagesLength: number;
  resetPagination: () => void;
  setTotalMessageCount: (count: number) => void;
  stateCoordination: any;
}

export const useAiAssistantEffects = ({
  currentSessionId,
  messagesLength,
  resetPagination,
  setTotalMessageCount,
  stateCoordination
}: UseAiAssistantEffectsProps) => {
  // ==================== ALL REFS AT TOP LEVEL ====================
  const lastSessionIdRef = useRef<string | null>(null);
  const lastMessagesLengthRef = useRef<number>(0);

  // ==================== SESSION CHANGE EFFECT - TOP LEVEL ====================
  useEffect(() => {
    if (currentSessionId && currentSessionId !== lastSessionIdRef.current) {
      lastSessionIdRef.current = currentSessionId;
      resetPagination();
      setTotalMessageCount(messagesLength);
    }
  }, [currentSessionId, resetPagination, setTotalMessageCount, messagesLength]);

  // ==================== MESSAGE COUNT TRACKING EFFECT - TOP LEVEL ====================
  useEffect(() => {
    if (stateCoordination && messagesLength !== lastMessagesLengthRef.current) {
      lastMessagesLengthRef.current = messagesLength;
      // Only log significant changes to reduce noise
      if (messagesLength % 5 === 0 && messagesLength > 0) {
        // Reduced logging frequency for performance
      }
    }
  }, [stateCoordination, messagesLength]);
};
